import { ChevronRight } from "lucide-react";
import TickIcon from "../../../assets/svgs/common/tick.svg";
import { ThreeDWrapper } from "../core/3d-wrapper.core";
import { Badge } from "../core/badge.core";
import Button from "../core/button.core";
import type { IBrandCampaign } from "../../hooks/http/campaigns/get-brand-campaigns.hook";
import { useNavigate } from "react-router-dom";
import { MilestoneRewardType } from "../../../z/brand/campaign-form.brand.z";

export default function CampaignCard({
	redirect,
	campaign,
}: {
	campaign: IBrandCampaign;
	redirect: string;
}) {
	const navigate = useNavigate();
	function TypeHandler({ type }: { type: MilestoneRewardType }) {
		switch (type) {
			case MilestoneRewardType.CASH:
				return "Cash";
			case MilestoneRewardType.PRODUCT:
				return "Product";
			case MilestoneRewardType.CASH_PRODUCT:
				return "Cash & Product";
			default:
				return "Unknown";
		}
	}
	return (
		<ThreeDWrapper className="flex flex-col p-0" hover={false}>
			<div className="flex justify-between items-center p-5 w-full">
				<div className="flex flex-col gap-4">
					<div className="flex items-center gap-2">
						<Badge
							variant="3d"
							className="flex items-center gap-1 bg-primarybuttonbg w-fit"
						>
							<TickIcon />
							live
						</Badge>
						<Badge variant="3d" className="flex items-center gap-1 w-fit">
							<TypeHandler type={campaign.milestoneRewardType} />
						</Badge>
					</div>
					<p className="font-semibold text-xl">{campaign.name}</p>
				</div>
				<Button
					onClick={() => {
						navigate(redirect);
					}}
					className="px-4 py-2 text-sm"
					variant="secondary"
				>
					View campaign <ChevronRight className="w-4 h-4" />
				</Button>
			</div>
		</ThreeDWrapper>
	);
}
